import { render, staticRenderFns } from "./MemberOrders.vue?vue&type=template&id=095e6a00&lang=pug&"
import script from "./MemberOrders.vue?vue&type=script&lang=js&"
export * from "./MemberOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports